<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{ $route.meta.title }}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{path: '/'}">首页</el-breadcrumb-item>
        <el-breadcrumb-item>考试培训管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">搜索</template>

      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">

        <div class="re-el-form__flex">
          <el-form-item label="知识库名称"
                        prop="name">
            <el-input style="width: 100%;"
                      v-model="search.name"
                      clearable
                      placeholder="请输入知识库名称搜索">
            </el-input>
          </el-form-item>
          <el-form-item label="是否通用"
                        prop="is_common">
            <el-select v-model="search.is_common"
                       placeholder="请选择状态"
                       class="width-max"
                       clearable>
              <el-option v-for="item in options.IsCommonStatus"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属客户"
                        prop="customerid">
            <remote-select
              class="width-max"
              clearable
              multiple
              id-key="number"
              label-key="name"
              value-key="id"
              placeholder="请输入客户关键字"
              v-model="search.customerid"
              :query-request="getCustomerTable"
              :find-request="getCustomerDetail">
            </remote-select>
          </el-form-item>

          <el-form-item label="知识库状态"
                        prop="status">
            <el-select v-model="search.status"
                       placeholder="请选择知识库状态"
                       class="width-max"
                       clearable>
              <el-option v-for="item in options.KnowledgeStatus"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人"
                        prop="creator_id">
            <remote-select
              class="width-max"
              clearable
              multiple
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入创建人"
              v-model="search.creator_id"
              :query-request="(params)=>getPlatformUsersIndex(Object.assign(params, {usertype: [1, 2, 3, 4, 5], status_lists: [1, 2]}))"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="创建时间"
                        prop="created_at">
            <el-date-picker v-model="search.created_at"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置</el-button>

        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <div class="margin b15">
        <el-button type="primary"
                   @click="createTrainingKnowledge"
                   size="small">创建知识库
        </el-button>
      </div>

      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         key="id"
                         label="ID"></el-table-column>
        <el-table-column prop="name"
                         key="name"
                         label="知识库名称">
          <template slot-scope="scope">
            <span class="knowledge-name">
              <i class="el-icon-folder knowledge-name__icon"></i>
              <span>{{ scope.row.name }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="is_common"
                         key="is_common"
                         label="是否通用">
          <template slot-scope="scope">
            <span class="knowledge-tag"
                  :class="getIsCommonTagClass(scope.row.is_common)">
              {{ getOptionLabel('IsCommonStatus', scope.row.is_common) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="customerid"
                         key="customerid"
                         label="所属客户">
          <template slot-scope="scope">
            <span v-if="scope.row.customerid">{{ scope.row.customer_name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         key="status"
                         label="状态">
          <template slot-scope="scope">
            <span class="knowledge-tag"
                  :class="getStatusTagClass(scope.row.status)">
              {{ getKnowledgeStatusLabel(scope.row.status) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         key="created_at"
                         label="创建时间"></el-table-column>
        <el-table-column prop="creator_id"
                         key="creator_id"
                         label="创建人">
          <template slot-scope="scope">
            <span v-if="scope.row.creator_id">{{ scope.row.user_name }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         :key="`operation`"
                         width="150">
          <template slot-scope="scope">
            <el-button type="primary"
                       plain
                       @click="editTrainingKnowledge(scope.row.id)"
                       size="mini">修改
            </el-button>
            <el-button v-if="canActiveKnowledge(scope.row.status) && isSuperAdmin"
                       type="success"
                       plain
                       @click="changeTrainingKnowledgeStatus(scope.row)"
                       size="mini">激活
            </el-button>
            <el-button v-if="Number(scope.row.status) === consts.STATUS_ACTIVE && isSuperAdmin"
                       type="info"
                       plain
                       @click="changeTrainingKnowledgeStatus(scope.row)"
                       size="mini">作废
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <el-dialog :title="dialogTitle"
               :visible.sync="dialogVisible"
               width="680px"
               @closed="handleDialogClosed">
      <el-form :model="dialogForm"
               :rules="dialogRules"
               ref="dialogForm"
               label-width="150px">
        <el-form-item label="知识库名称"
                      prop="name">
          <el-input v-model="dialogForm.name"
                    placeholder="请输入知识库名称"></el-input>
        </el-form-item>
        <el-form-item label="是否通用"
                      prop="is_common">
          <el-radio-group v-model="dialogForm.is_common"
                          :disabled="isDialogEditLocked"
                          @change="handleDialogIsCommonChange">
            <el-radio :label="1">通用</el-radio>
            <el-radio :label="0">专用</el-radio>
          </el-radio-group>
          <div class="knowledge-dialog__tips">通用知识库适用于所有用户，专用知识库仅适用于特定客户</div>
        </el-form-item>
        <el-form-item v-if="Number(dialogForm.is_common) === 0"
                      label="所属客户"
                      prop="customerid">
          <remote-select
            class="width-max"
            clearable
            id-key="number"
            label-key="name"
            value-key="id"
            placeholder="请选择客户"
            v-model="dialogForm.customerid"
            :disabled="isDialogEditLocked"
            :query-request="getCustomerTable"
            :find-request="getCustomerDetail">
          </remote-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary"
                   @click="saveTrainingKnowledge">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import trainingMixins from '@views/training/training.mixins'
import { isSuperAdminUser } from '@views/training/training-user'
import { consts, options, isKnowledgeDialogEditLocked } from '@views/training/training-knowledge.constants'
import { NumberArray } from '@utils/common'

export default {
  mixins: [table, trainingMixins],
  components: {},
  data () {
    return {
      options,
      consts,
      search: {
        created_at: [],
        status: null,
        is_common: null,
        creator_id: [],
        name: null,
        customerid: [],
      },
      searchFieldType: {
        status: Number,
        is_common: Number,
        customerid: Array,
        creator_id: NumberArray,
        created_at: Array,
      },
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
      },
      dialogTitle: '',
      dialogVisible: false,
      dialogId: 0,
      dialogStatus: consts.STATUS_NEW,
      refreshAfterDialogClose: false,
      dialogForm: {
        name: '',
        is_common: 1,
        customerid: null,
      },
      dialogRules: {
        name: [
          {required: true, message: '请输入知识库名称', trigger: 'blur'},
        ],
        is_common: [
          {required: true, message: '请选择是否通用', trigger: 'change'},
        ],
        customerid: [
          {
            validator: (rule, value, callback) => {
              if (Number(this.dialogForm.is_common) === 0 && !value) {
                callback(new Error('请选择客户'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      loginUser: state => state.login.user || {},
    }),
    isSuperAdmin () {
      return isSuperAdminUser(this.loginUser)
    },
    isDialogEditLocked () {
      return isKnowledgeDialogEditLocked(this.dialogId, this.dialogStatus)
    },
  },
  methods: {
    ...request.map([
      'getPlatformUsersDetail',
      'getPlatformUsersIndex',
      'getCustomerTable',
      'getCustomerDetail',
      'getTrainingKnowledgeDetail'
    ]),
    /**
     * 获得表格数据
     * @param {*} params
     *
     */
    getTableData (params) {
      return request.page('getTrainingKnowledgeTable', params)
    },
    createTrainingKnowledge () {
      this.dialogTitle = '新增知识库'
      this.dialogId = 0
      this.dialogStatus = consts.STATUS_NEW
      this.refreshAfterDialogClose = false
      this.resetDialogForm()
      this.dialogVisible = true
    },
    editTrainingKnowledge (id) {
      request.loading('getTrainingKnowledgeDetail', {id}).then(({data}) => {
        this.dialogTitle = '修改知识库'
        this.dialogId = id * 1
        this.dialogStatus = Number(data.status) || consts.STATUS_NEW
        this.dialogForm = {
          name: data.name,
          is_common: Number(data.is_common),
          customerid: data.customerid ? String(data.customerid) : null,
        }
        this.dialogVisible = true
        this.handleDialogIsCommonChange(this.dialogForm.is_common)
      })
    },
    resetSearch () {
      this.$refs[this.refSearchForm].resetFields()
    },
    closeDialog () {
      this.refreshAfterDialogClose = false
      this.dialogVisible = false
    },
    closeDialogRefresh () {
      this.refreshAfterDialogClose = true
      this.dialogVisible = false
    },
    changeTrainingKnowledgeStatus (row) {
      let isActive = Number(row.status) === consts.STATUS_ACTIVE
      let actionText = isActive ? '作废' : '激活'
      let successText = isActive ? '作废成功' : '激活成功'
      let apiName = isActive ? 'banTrainingKnowledge' : 'activeTrainingKnowledge'
      let message = isActive ? `确定要${actionText}知识库【${row.name}】吗？作废后该知识库不会从已有关联中移除，但创建新资源时不可选择。` : `确定要${actionText}知识库【${row.name}】吗？`
      this.$confirm(message, '提示', {type: 'warning'}).then(() => {
        request.common(apiName, row.id).then(() => {
          this.$message.success(successText)
          this.onRefresh()
        })
      })
    },
    canActiveKnowledge (status) {
      if (status === null || status === undefined || status === '' || status === 0) {
        return false
      }
      return [1, 3].includes(Number(status))
    },
    getKnowledgeStatusLabel (status) {
      return this.getOptionLabel('KnowledgeStatusTable', status) || '未知状态'
    },
    handleDialogClosed () {
      let shouldRefresh = this.refreshAfterDialogClose
      this.refreshAfterDialogClose = false
      this.dialogId = 0
      this.dialogStatus = consts.STATUS_NEW
      this.resetDialogForm()
      if (shouldRefresh) {
        this.onRefresh()
      }
    },
    resetDialogForm () {
      this.dialogForm = {
        name: '',
        is_common: 1,
        customerid: null,
      }
      this.$nextTick(() => {
        if (this.$refs.dialogForm) {
          this.$refs.dialogForm.clearValidate()
        }
      })
    },
    handleDialogIsCommonChange (value) {
      if (this.isDialogEditLocked) {
        return
      }
      if (Number(value) === 1) {
        this.dialogForm.customerid = null
      }
      this.$nextTick(() => {
        if (this.$refs.dialogForm) {
          this.$refs.dialogForm.clearValidate('customerid')
        }
      })
    },
    getDialogSubmitData () {
      let isCommon = Number(this.dialogForm.is_common)
      return {
        id: this.dialogId,
        name: this.dialogForm.name,
        is_common: isCommon,
        customerid: isCommon === 1 ? 0 : this.dialogForm.customerid,
      }
    },
    saveTrainingKnowledge () {
      this.$refs.dialogForm.validate((valid) => {
        if (!valid) {
          return
        }
        let apiName = this.dialogId ? 'updateTrainingKnowledge' : 'createTrainingKnowledge'
        request.common(apiName, this.getDialogSubmitData()).then(_ => {
          this.$message.success('保存成功')
          this.closeDialogRefresh()
        })
      })
    },
    getIsCommonTagClass (isCommon) {
      return Number(isCommon) === 1 ? 'knowledge-tag--success' : 'knowledge-tag--default'
    },
    getStatusTagClass (status) {
      if (Number(status) === this.consts.STATUS_NEW) {
        return 'knowledge-tag--primary'
      }
      if (Number(status) === this.consts.STATUS_ACTIVE) {
        return 'knowledge-tag--success'
      }
      if (Number(status) === this.consts.STATUS_BANNED) {
        return 'knowledge-tag--warning'
      }
      return 'knowledge-tag--default'
    },
  },
}
</script>


<style lang="scss"
       scoped>
.knowledge-name {
  display: inline-flex;
  align-items: center;
  line-height: 20px;
  color: #1f2d3d;

  &__icon {
    margin-right: 8px;
    color: #f5a623;
    font-size: 14px;
  }
}

.knowledge-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 22px;
  padding: 0 12px;
  border-radius: 11px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 22px;
  white-space: nowrap;
}

.knowledge-tag--success {
  color: #00a854;
  background-color: #d9f7e7;
}

.knowledge-tag--default {
  color: #1f2d3d;
  background-color: #f4f5f7;
}

.knowledge-tag--danger {
  color: #f56c6c;
  background-color: #fdf6ec;
}

.knowledge-tag--primary {
  color: #409EFF;
  background-color: #ecf5ff;
}

.knowledge-dialog__tips {
  color: #8492a6;
  font-size: 12px;
  line-height: 20px;
}

.knowledge-dialog__alert {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/training/pages/knowledge/TrainingKnowledgeTable.vue